import { useEffect, useRef, type ReactElement } from 'react';
import { Box, Divider, Text } from '@citibox-panel/ui';

export interface PageIntroProps {
  // Set by the host only for a move made from inside the panel.
  focusHeadingOnArrival?: boolean;
}

// The screen's own words: which programme it belongs to and what it is. Page content rather than
// chrome — it scrolls, the band above it does not. Same type as door-access's intro, so the two
// operations surfaces title themselves identically.
//
// TODO: i18n — copy en ES hasta Fase 1.
export function PageIntro({ focusHeadingOnArrival = false }: PageIntroProps): ReactElement {
  const titleRef = useRef<HTMLElement>(null);
  useEffect(() => {
    if (focusHeadingOnArrival) titleRef.current?.focus();
  }, [focusHeadingOnArrival]);
  return (
    <Box sx={{ mb: 4 }}>
      <Text variant="overline" component="p" bold dense>
        CARRIERS · LISTAS DE EXCLUSIÓN
      </Text>
      <Divider sx={{ my: 2 }} />
      <Text ref={titleRef} focusTarget variant="h5" component="h1" bold>
        Listas de exclusión de carriers
      </Text>
    </Box>
  );
}
